import React from 'react';
import Cart from '../../Shop/Cart/Cart';

import './PageHeader.scss'

function PageHeader(props) {
    return (
        <div>
            <Cart cartOpen={props.cartOpen} handleCartOpen={props.handleCartOpen}></Cart>
            <div className="PageHeader">
                <div className="container">
                    {props.title && <h1 id="PageTitle">{props.title}</h1>}
                    {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
                    {props.children}
                    {props.nav ?
                        <nav className="sectionNav">
                            {props.nav}
                        </nav>
                    : null}
                </div>
            </div>
        </div>
    )
}

export default PageHeader;